module.exports = __webpack_public_path__ + "static/media/1025517.68edcbc3.jpg";